import { getDeviceId } from '../utils/tracking';
import { getTrackingPixelUrl } from '../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ViralTrackingPixel({
  viralLinkType,
  portalId,
  userId,
  environment,
  isExternalLink
}) {
  return /*#__PURE__*/_jsx("img", {
    src: getTrackingPixelUrl({
      viralLinkType,
      deviceId: getDeviceId(),
      portalId,
      userId,
      environment,
      isExternalLink
    }),
    style: {
      display: 'none'
    },
    "data-test-id": `viral-pixel-${viralLinkType}`
  });
}